import React, { useEffect, useState } from "react";
import { renderError } from "../../../helpers/errors";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";

const BRINDE_ME = 'brinde.me';

const filterAdminsWithoutBrindeMe = (list) => {
    if (!Array.isArray(list)) return [];
    return list.filter(admin => {
        const name = (admin.name || '').toLowerCase();
        const email = (admin.email || '').toLowerCase();
        return !name.includes(BRINDE_ME) && !email.includes(BRINDE_ME);
    });
};

export const SelectAdmin = ({ selectedAdmin, setSelectedAdmin, nullable, labelNullable, nullableValue, pipelineId, onLoad }) => {
    const [loading, setLoading] = useState(true);
    const [admins, setAdmins] = useState([]);

    useEffect(() => {
        getAdmins();
    }, [pipelineId]);

    const getAdmins = () => {
        setLoading(true);

        // Com pipelineId, lista apenas os usuários com acesso àquele painel — não
        // faz sentido atribuir um card a quem não enxerga o painel.
        const url = pipelineId ? `/list?pipeline_id=${pipelineId}` : `/list`;
        api.get(url).then(res => {
            const raw = res.data?.resources ?? res.data?.data ?? (Array.isArray(res.data) ? res.data : []);
            const list = Array.isArray(raw) ? raw : [];
            const filtered = filterAdminsWithoutBrindeMe(list);
            setAdmins(filtered);
            if (onLoad) onLoad(filtered);
        }).catch(error => {
            renderError(error);
        }).then(() => {
            setLoading(false);
        });
    };

    const baseOptions = createOptions(admins, 'name', 'id', false);
    const options = nullable === true
        ? [{ label: labelNullable ?? 'Nenhuma opção', value: nullableValue ?? null }, ...baseOptions]
        : baseOptions;

    return (
        <InputSelect
            loading={loading}
            label={`Responsável`}
            options={options}
            value={selectedAdmin}
            change={setSelectedAdmin}
        />
    );
};

export default SelectAdmin;